module.exports = __webpack_public_path__ + "img/recupel1.d263d70a.jpg";